import React, { useState, useEffect, useContext } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Link } from "gatsby";

import { I18nContext } from "../i18n/index";
import { setHTMLElementFixedPosition } from "../functions/Utilities.js";

import "./Styles/header.css";
import "./Styles/NavMenu.css";
import LazyImage from "../shared/components/LazyImage/LazyImage.js";

export default function NavMenu() {
  const { langCode, translate } = useContext(I18nContext);

  const isMobileState = useSelector(
    (state) => state.mainReducer.isMobile,
    shallowEqual
  );

  const currentScreenWidthState = useSelector(
    (state) => state.mainReducer.currentScreenWidth,
    shallowEqual
  );

  const navCatsState = useSelector(
    (state) => state.menuReducer.navCats,
    shallowEqual
  );

  const PROJECT_LINK_HARD = "https://cnr11de1.avetti.io/preview/";

  const [navMenuOpen, setNavMenuOpen] = useState(false);

  useEffect(() => {
    setHTMLElementFixedPosition(navMenuOpen);
    return () => {
      setHTMLElementFixedPosition(false);
    };
  }, [navMenuOpen]);

  const handleCategoryChange = () => {
    if (isMobileState) {
      setNavMenuOpen(!navMenuOpen);
    }
  };

  return (
    <nav className="nav-menu-content-desktop primary-nav menu-dark">
      <div className="ab">
        <ul className="menu-list nav-hover-1 sf-menu clear list-none">
          {navCatsState.childs &&
            navCatsState.childs.map((cat) => {
              let catName = cat.description;
              let arrURL = cat.URL.split(`/`);
              let lastURL = arrURL[arrURL.length - 1];
              let className = `navlink-${lastURL}`;
              let tempUrl = cat.URL.replace("shop/", "");
              let langTemp = tempUrl.includes(langCode) ? "" : `${langCode}/`;

              return (
                <li key={cat.cid} className="has-dropdown megamenu">
                  <Link
                    className="menuCat"
                    to={"/" + tempUrl}
                    onClick={() => handleCategoryChange()}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: catName,
                      }}
                      style={{ textTransform: "capitalize" }}
                    />
                  </Link>

                  {cat.childs.length > 0 ? (
                    <ul
                      className="sub-menu megamenu-wrapper flex"
                      id={cat.description.replace(" ", "").replace(" ", "")}
                    >
                      {cat.childs.map((subcat) => (
                        <li key={subcat.cid} className="hvr-col">
                          <Link
                            to={"/" + subcat.URL.replace("shop/", "")}
                            onClick={() => handleCategoryChange()}
                          >
                            <LazyImage
                              classNameImg={`secondLevelImg${subcat.description}`}
                              src={`https://ik.imagekit.io/ofb/store/${subcat.image}?tr=w-135,h-135,dpr-2,pr-true,f-auto`}
                              alt={`${subcat.description}`}
                              height="135px"
                            />
                            {/* <p>{subcat.description}</p> */}
                          </Link>

                          <ul className="megamenu-child">
                            {subcat.childs.map((subsubcat, index) => (
                              <li className="subchilds" key={index}>
                                <Link
                                  to={"/" + subsubcat.URL.replace("shop/", "")}
                                  onClick={() => handleCategoryChange()}
                                >
                                  <p>{subsubcat.description}</p>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <></>
                  )}
                </li>
              );
            })}
        </ul>
      </div>
    </nav>
  );
}
